import { WEB_URL } from "@/config/endpoints";


export function blogBreadcrumbSchema({
  blogTitle,homeUrl,blogUrl,locale
}) {
  const blogListUrl = WEB_URL+`${locale=='es-mx'? `/es-mx/blogs`:`/blogs`}`;
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": homeUrl
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Blog",
        "item": blogListUrl
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": blogTitle,
        ...(blogUrl ? { "item": blogUrl } : {})
      }
    ]
  }
}
